<template>
  <NuxtLayout>
    <NuxtPage />
    <ClientOnly>
      <GlobalConfirmModal />
    </ClientOnly>
  </NuxtLayout>
</template>
